import { useEffect, useState } from "react";

function getMatches(query) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(query).matches;
}

export function useMediaQuery(query) {
  var state = useState(function () {
    return getMatches(query);
  });
  var matches = state[0];
  var setMatches = state[1];

  useEffect(function () {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      setMatches(false);
      return undefined;
    }

    var mediaQueryList = window.matchMedia(query);
    var handleChange = function (event) {
      setMatches(event.matches);
    };

    setMatches(mediaQueryList.matches);

    if (typeof mediaQueryList.addEventListener === "function") {
      mediaQueryList.addEventListener("change", handleChange);
      return function () {
        mediaQueryList.removeEventListener("change", handleChange);
      };
    }

    mediaQueryList.addListener(handleChange);
    return function () {
      mediaQueryList.removeListener(handleChange);
    };
  }, [query]);

  return matches;
}

export default useMediaQuery;
